import { Dropdown } from 'primereact/dropdown'
import { InputNumber } from 'primereact/inputnumber'

import { cap } from '../../../State'
import { translations } from '../../../translations'
const language = cap.language.state || 'IT'
const t = translations[language]

export const DropdownElement = ({
  name,
  index: key,
  value,
  options,
  selectedFilters: [selectedFilters, setSelectedFilters],
  inputValues: [inputValues, setInputValues],
  inputRimborso: [inputRimborso, setInputRimborso] = [],
  inputNoRimborso: [inputNoRimborso, setInputNoRimborso] = [],
  flagAbilitazione: [flagAbilitazione, setFlagAbilitazione] = []
}) => {
  const selectedOption = selectedFilters[key]
  const optionsForDisplay = [
    ...options.filter(
      (option) =>
        !Object.values(selectedFilters).some(
          (selectedFilter) => selectedFilter.code === option.code
        )
    ),
    selectedOption
  ]

  const removeFilter = (index) => {
    const newSelectedFilters = [...selectedFilters]
    newSelectedFilters.splice(index, 1)
    setSelectedFilters(newSelectedFilters)
  }

  const onSelectChange = (e, key) => {
    const newSelectedFilters = [...selectedFilters]
    newSelectedFilters[key] = e.value
    setSelectedFilters(newSelectedFilters)
  }

  const handleValueRefundableChange = (newValue, isRimborso) => {
    const newInputRimborso = [...inputRimborso]
    const newInputNoRimborso = [...inputNoRimborso]

    if (isRimborso) {
      newInputRimborso[key] = newValue
      newInputNoRimborso[key] = inputValues[key] - newValue
    } else {
      newInputNoRimborso[key] = newValue
      newInputRimborso[key] = inputValues[key] - newValue
    }

    setInputRimborso(newInputRimborso)
    setInputNoRimborso(newInputNoRimborso)
  }

  const numberField = (label, inputProps) => (
    <div className="nfield">
      <label>{label}</label>
      <div className="n-input-number">
        <InputNumber
          className="inputNumbers"
          mode="decimal"
          showButtons
          min={0}
          max={50}
          {...inputProps}
        />
      </div>
    </div>
  )

  return (
    <div className="community-filter-row" key={key}>
      <div className="nfield" style={{ minWidth: 200 }}>
        <label>{t.tipo}</label>
        <Dropdown
          value={selectedOption}
          onChange={(e) => onSelectChange(e, key)}
          options={optionsForDisplay}
          optionLabel="name"
          placeholder={t.cpAggiungiFiltri}
          style={{ width: '100%' }}
        />
      </div>
      {numberField(t.nProposte, {
        placeholder: selectedOption ? selectedOption.name : '',
        inputId: `minmax-buttons-${value.code}`,
        value: inputValues[key],
        onValueChange: (e) => {
          inputValues[key] = e?.value || 0
          setInputValues([...inputValues])
          if (inputRimborso) {
            inputRimborso[key] = e?.value || 0
            setInputRimborso([...inputRimborso])
          }
          if (inputNoRimborso) {
            inputNoRimborso[key] = 0
            setInputNoRimborso([...inputNoRimborso])
          }
        }
      })}
      {name === 'Treno' && flagAbilitazione && (
        <>
          {numberField(t.cpNRimborsabili, {
            placeholder: selectedOption ? selectedOption.name : '',
            inputId: `rimborso-${value.code}`,
            value: inputRimborso?.[key],
            max: inputValues[key],
            onValueChange: (e) => handleValueRefundableChange(e.value, true)
          })}
          {numberField(t.cpNNonRimborsabili, {
            placeholder: t.cpNNonRimborsabili,
            inputId: `no-rimborso-${value.code}`,
            value: inputNoRimborso?.[key],
            max: inputValues[key],
            onValueChange: (e) => handleValueRefundableChange(e.value, false)
          })}
        </>
      )}
      <button
        type="button"
        className="naction-btn"
        title={t.rimuovi}
        onClick={() => removeFilter(key)}
        style={{ alignSelf: 'flex-end', marginBottom: 1 }}
      >
        <i className="pi pi-times" style={{ fontSize: 14 }} />
      </button>
    </div>
  )
}
